import { React, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import firebase from "firebase/compat/app"
import { firebaseConfig } from "../firebase-config";
import { getAuth, deleteUser } from 'firebase/auth';

import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { DialogContent, DialogContentText, DialogTitle, Dialog, DialogActions, createTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core';
import { Box, Chip } from '@mui/material';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

function CloseAccount() {

  const [confirmation, setConfirmation] = useState(false)

  let navigate = useNavigate();

  const closeAcc = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      deleteUser(user).then(() => {
          console.log("success")
          localStorage.setItem("isAuth", "false");
        }).catch((error) => {
          console.log(error)
        });
      navigate("/");

  }

  const handleConfirm = () => {
    setConfirmation(true);
  }
  
  const handleReject = () => {
    setConfirmation(false);
  }

  const boxStyle = { display:'flex', justifyContent:'center' };
  const cardStyle = { minWidth: 500, padding: "10px 5px", margin: "0 auto", justifyContent:'center' };

  const primaryBtn1 = { mt:1, mb:2, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'} };
  const primaryBtn2 = { mt:1, mb:1, bgcolor: '#7B1113', ":hover": {bgcolor: "#5A0C0E", color: 'white'} };
  const secondaryBtn1 = { mt:1, mb:1, color: '#666666', ":hover": {color: '#212121'} };

  return (
    <ThemeProvider theme={theme}>
      {/* DELETE PROMPT */}
      <Grid>
        <Typography fontWeight="bold" component="h1" variant="h5" sx={{ mb:2, color: '#D43030' }}>
          Danger Zone
        </Typography>
        <Box sx={{ border: 1, color: '#D43030', p:5 }}>
          <Typography sx={{ mb: 5 }}>
            Careful, this action is not reversible. Once you delete an account, there is no going back. Please be certain if you want to delete the current account.
          </Typography>
          <form>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" sx={primaryBtn1} fullWidth
                onClick={e => {
                  e.preventDefault()
                  handleConfirm()
                }}
                >
                <b>DELETE CURRENT USER</b>
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Grid>

    {/* CONFIRMATION DIALOGUE */}
    <Dialog open={confirmation} onClose={handleReject} PaperProps={{ sx : { maxWidth: 400} }}>
      <DialogTitle>
        {"Delete Account?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Deleting this account will permanently remove your access from the admin dashboard.
        </DialogContentText>
      </DialogContent>
      <DialogActions>

        {/* YES BUTTON */}
        <Button type="submit" variant="outlined" size="small" sx={secondaryBtn1}
        onClick={e => {
          e.preventDefault();
          closeAcc()
        }}>Yes, Delete Account</Button>

        {/* NO BUTTON */}
        <Button onClick={handleReject} autoFocus type="submit" variant="contained" size="small" sx={primaryBtn2}>
          No, Keep Account
        </Button>
      </DialogActions>
    </Dialog>
  </ThemeProvider>
  )
}

export default CloseAccount